import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_USER_DETAILS: {
        url: "gebruiker/get-user-details",
        method: "post",
    },

    UPDATE_GEBRUIKER_DETAIL: {
        url: "gebruiker/update-details",
        method: "post",
    },

    GET_CONTRACT_TYPES: {
        url: "contracttypes",
        method: "get",
    },

    GET_SCHOOL_LIST: {
        url: "gebruiker/school-lists",
        method: "get",
    },

    GET_COMMUNITY_LIST: (id) => ({
        url: `gebruiker/communities?iAdminId=${id}`,
        method: "get",
    }),

    GET_COMMUNITY_ADMIN_LIST: (id) => ({
        url: `gebruiker/community-admin-list?iAdminId=${id}`,
        method: "get",
    }),

    SEND_SMS: {
        url: "send-sms",
        method: "post",
    },
};

export const useGebruikerDetail = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_USER_DETAILS);

export const useUpdateGebruikerDetail = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_GEBRUIKER_DETAIL);

export const useContractTypes = (communityId, enabled = true) =>
    useApiFetcherSWR(
        enabled && communityId
            ? {
                ...API_ENDPOINT.GET_CONTRACT_TYPES,
                params: {
                    iCommunityId: communityId,
                },
            }
            : null
    );

export const useSchoolList = (iCommunityId, iAdminId, enabled = true) =>
    useApiFetcherSWR(
        enabled && iCommunityId && iAdminId
            ? {
                ...API_ENDPOINT.GET_SCHOOL_LIST,
                params: {
                    iCommunityId,
                    iAdminId,
                },
            }
            : null
    );

export const useCommunityList = (adminId, enabled = true) =>
    useApiFetcherSWR(
        enabled && adminId
            ? API_ENDPOINT.GET_COMMUNITY_LIST(adminId)
            : null
    );

export const useCommunityAdminList = (adminId, enabled = true) =>
    useApiFetcherSWR(
        enabled && adminId
            ? API_ENDPOINT.GET_COMMUNITY_ADMIN_LIST(adminId)
            : null
    );

export const useSendSMS = () =>
    useApiFetcherSWR(API_ENDPOINT.SEND_SMS);